import React from 'react'
import css from './link.module.scss'

export default function Link({ children, ...props }: any) {
  return (
    <span className={css.s_link} {...props}>
      {children}
    </span>
  )
}
